import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LayersIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { brand, heroBadges, heroImage } from '../data/content';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="w-full bg-white pb-16 pt-12 md:pb-24 md:pt-16" data-id="element-137" data-mp="4m8nyh6uizn1">
      <div className="mx-auto w-full max-w-content px-5 text-center md:px-8" data-id="element-138" data-mp="4jvx1ej41exu">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        ease
      }} className="inline-flex items-center gap-2 font-display text-base font-extrabold uppercase tracking-[0.16em] text-blue-600 md:text-lg" data-id="element-139" data-mp="128phrcgdev41">
          <LayersIcon className="h-5 w-5" aria-hidden="true" data-id="element-140" data-mp="nbydaoruat7k" />
          {brand.name}
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.05,
        ease
      }} className="mx-auto mt-6 max-w-4xl font-display text-[2.5rem] font-extrabold leading-[1.04] tracking-tight text-ink sm:text-5xl md:text-6xl" data-id="element-141" data-mp="3czfme2gnud7m">
          {brand.promise}
          <br data-id="element-142" data-mp="39b4fyxmj3o1c" />
          <span className="text-blue-600" data-id="element-143" data-mp="399jm7a81g94j">{brand.promiseAccent}</span>
        </motion.h1>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.14,
        ease
      }} src={heroImage} alt="Atlas Kinesio-Visual: los 100 mapas maestros impresos junto a los 6 bonos incluidos" className="mx-auto mt-10 w-full max-w-2xl" width={1240} height={1240} data-id="element-144" data-mp="3e8egb8bghk3y" />

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45,
        delay: 0.2,
        ease
      }} className="mx-auto mt-10 max-w-3xl" data-id="element-145" data-mp="2vjq02znx42yi">
          <p className="text-xl leading-relaxed text-blue-900/80 md:text-2xl" data-id="element-146" data-mp="2ljz1omw8l3t5">{brand.subtitle}</p>

          <ul className="mt-7 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm font-semibold text-blue-900/70" data-id="element-147" data-mp="s3cmudv0pps5">
            {heroBadges.map(badge => <li key={badge} className="inline-flex items-center gap-1.5" data-id="element-148" data-mp="id032nv120n2">
                <CheckIcon className="h-4 w-4 text-mint-500" aria-hidden="true" data-id="element-149" data-mp="ddne9xklijhu" />
                {badge}
              </li>)}
          </ul>

          <div className="mt-9" data-id="element-150" data-mp="1ayt8l57pjtdj">
            <CtaButton size="xl" className="w-full max-w-2xl" data-id="element-151" data-mp="1622jxthu7pgi">
              Quiero el Atlas completo ahora
            </CtaButton>
          </div>

          <p className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-blue-900/70" data-id="element-152" data-mp="111525i0qoxfj">
            <ShieldCheckIcon className="h-4 w-4 text-mint-500" aria-hidden="true" data-id="element-153" data-mp="x0l328wlvjqr" />
            Garantía de 7 días o te devolvemos tu dinero
          </p>
        </motion.div>
      </div>
    </section>;
}